export default __webpack_public_path__ + "9761fdf6a5a925517eacfa45225a0d7c.svg";